import { format } from "date-fns";

import type { Appointment } from "services/types/appointments.type";

import type { CustomPrintFormMetadata } from "./use-custom-print-form-preview.hook";

/** What a form opened from this appointment is signed, dated, filed and headed with. */
export const appointmentFormMetadata = (
  appointment: Appointment
): CustomPrintFormMetadata => {
  const fileNamePostfix = !appointment
    ? ""
    : `${appointment?.id} - ${appointment?.appointmentType?.name} ${
        appointment?.startDate
          ? format(new Date(appointment?.startDate || ""), "yyyy-MM-dd")
          : ""
      } ${format(new Date(), "yyyyMMddHHmmss")}.pdf`;

  return {
    staffMember: appointment?.staffMember,
    signedAt: appointment.startDate,
    dateOfVisit: appointment.startDate,
    fileNamePostfix,
    clinicId: appointment?.clinic?.id
  };
};
